<template>
  <div class="chat-item">
    <div class="other" v-if="!source.is_b">
      <div class="avatar">
        <img src="../../assets/img/kehu.png" alt="" />
      </div>
      <div class="nt">
        <span>{{ $moment(source.ts).format("YYYY/MM/DD HH:mm:ss") }}</span>
        <!-- <span>{{ name }}</span> -->
      </div>
      <div class="msg" v-if="source.type === 'word'" style="white-space: pre-wrap;">{{ source.msg }}</div>
      <div class="img" v-if="source.type === 'pic'">
        <el-image
          style="width: 100px"
          :src="source.url"
          :preview-src-list="pList"
          crossOrigin="Anonymous"
        >
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" class="image-slot">加载失败</div>
        </el-image>
      </div>
      <div class="file" @click="download()" v-if="source.type === 'file'">
        <img src="../../assets/img/download.png" alt="" />
        <!-- <span> 文件.txt </span> -->
      </div>
    </div>

    <div class="my" v-else>
      <div class="avatar">
        <img src="../../assets/img/kefu.png" alt="" />
      </div>
      <div class="nt">
        <span>{{ $moment(source.ts).format("YYYY/MM/DD HH:mm:ss") }}</span>
        <!-- <span>{{ name }}</span> -->
      </div>
      <div class="msg" v-if="source.type === 'word'" style="white-space: pre-wrap;">{{ source.msg }}</div>
      <div class="img" v-if="source.type === 'pic'">
        <el-image
          style="width: 100px"
          :src="source.url"
          :preview-src-list="pList"
          crossOrigin="Anonymous"
        >
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" class="image-slot">加载失败</div>
        </el-image>
      </div>
      <div class="file" @click="download()" v-if="source.type === 'file'">
        <img src="../../assets/img/download.png" alt="" />
        <!-- <span> 文件.txt </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { fileType } from "../../utils/index";
export default {
  name: "chat-item",
  props: {
    index: {
      // index of current item
      type: Number,
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // pList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg']
    };
  },
  computed: {
    pList() {
      let a = [];
      a.push(this.source.url);
      return a;
    },
  },
  methods: {
    download() {
      window.location.href = this.source.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-item {
  display: flex;
  width: 100%;
  margin: 40px 0;
  padding: 0 20px;
  .other {
    width: 100%;
    position: relative;
    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0.2rem;
      transform: translateY(-50%);
      background: #409eff;
      img {
        width: 60%;
        height: 60%;
      }
    }
    .nt {
      font-size: 14px;
      left: 60px;
      top: -26px;
      position: absolute;
      color: #686868;
      span {
        padding-right: 0.1rem;
      }
      span:nth-child(2) {
        font-size: 0.1rem;
      }
    }
    .msg {
      position: relative;
      float: left;
      max-width: 60%;
      margin-left: 60px;
      padding: 6px 8px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 21px;
      background-color: #f3f3f3;
      word-break: break-all;
    }
    .msg:after {
      content: "";
      position: absolute;
      right: 100%;
      top: 10px;
      width: 14px;
      height: 14px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-bottom-width: 10px;
      border-bottom-color: #f3f3f3;
      border-radius: 0 0 0 32px;
      color: #f0f8ff;
    }
    .img {
      float: left;
      max-width: 60%;
      margin-left: 60px;

      img {
      }
    }
    .file {
      position: relative;
      float: left;
      max-width: 60%;
      margin-left: 60px;
      width: 120px;
      height: 80px;
      background-color: #f3f3f3;
      border-radius: 4px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .file:after {
      content: "";
      position: absolute;
      right: 100%;
      top: 10px;
      width: 14px;
      height: 14px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-bottom-width: 10px;
      border-bottom-color: #f3f3f3;
      border-radius: 0 0 0 32px;
      color: #f0f8ff;
    }
  }
  .my {
    width: 100%;
    position: relative;
    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      right: 0;
      position: absolute;
      top: 0;
      right: 0.2rem;
      transform: translateY(-50%);
      background: slateblue;
      img {
        width: 60%;
        height: 60%;
      }
    }
    .nt {
      font-size: 14px;
      right: 60px;
      top: -26px;
      position: absolute;
      color: #686868;
      span {
        padding-left: 0.1rem;
      }
      span:nth-child(1) {
        // font-size: 0.1rem;
      }
    }
    .msg {
      position: relative;
      float: right;
      max-width: 60%;
      margin-right: 60px;
      padding: 6px 8px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 21px;
      background-color: #daf4fe;
      color: #000000;
      word-break: break-all;
    }
    .msg:after {
      content: "";
      position: absolute;
      left: 100%;
      top: 10px;
      width: 14px;
      height: 14px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-bottom-width: 10px;
      border-bottom-color: #daf4fe;
      border-radius: 0 0 32px 0;
      color: #f0f8ff;
    }
    .img {
      float: right;
      max-width: 60%;
      margin-right: 60px;
      border-radius: 4px;

      img {
        border-radius: 4px;
      }
    }
    .file {
      position: relative;
      float: right;
      max-width: 60%;
      margin-right: 60px;
      width: 120px;
      height: 80px;
      background-color: #daf4fe;
      border-radius: 4px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .file:after {
      content: "";
      position: absolute;
      left: 100%;
      top: 10px;
      width: 14px;
      height: 14px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-bottom-width: 10px;
      border-bottom-color: #daf4fe;
      border-radius: 0 0 32px 0;
      color: #f0f8ff;
    }
  }
}
.image-slot {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #c0c4cc;
  background: #f5f7fa;
  font-size: 14px;
}
</style>